import Backbone from 'backbone';
import { addPromisesToBackbone } from './backbone-promised';
/* eslint-disable import/first */
addPromisesToBackbone(Backbone);
